export default __webpack_public_path__ + "static/media/slide9.ace92438.webp";